module.exports = require('./helpers/bundle-url').getBundleURL('jNzS2') + "logo.c51670a8.svg";